import { TextLine3, TextArea2 } from 'UtilComponents';
import { useGlobalStateSelector, words } from 'globalState';
import { handleClickApplyForCardRegistration } from './cardRegistration';
import { handleClickGoTop } from './monadomCore';
import iconSign from './history_edu_FILL0_wght400_GRAD0_opsz48.svg';
import cardRegistrationGuidelinesHtml from './cardRegistrationGuidelines.static.html';

// CARD REGISTRATION
function CardRegistration() {
  const state = useGlobalStateSelector(({ state }) => state);
  const keyPairsInPoolAll = useGlobalStateSelector( ({ state }) => state.keyPairs );
  const stateAssetInfo = useGlobalStateSelector( ({ state }) => state.assetInfo );
  const clientParameters = useGlobalStateSelector( ({ state }) => state.config.clientParameters );
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);

  // 登録ボタン

  const registerButton =
    <div className='flexRow justifyContentCenter widthMax marginTop1'>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ () => {
          handleClickApplyForCardRegistration(state, dispatch, keyPairsInPoolAll, stateAssetInfo, clientParameters);
        }}
      >
        <div>
          {words.signByOwnerAddressToRegister[state.language]}
        </div>
        <img className='size2x2' src={iconSign} alt='sign' />
      </button>
    </div>

  const headerFixed =
  <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
    <div className='flexRow justifyContentFlexEnd marginBottom1' >
      <button className='button2' onClick={ () => handleClickGoTop(state, dispatch, navigate) }>
        { words.back[state.language] }
      </button>
    </div>
  </div>;

  const headerRelative =
  <div className='widthMax height6 ' >
  </div>;


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn alignItemsCenter">
        { headerRelative }
        <div className='flexColumn alignItemsFlexStart width98vw borderKOM marginSide1 padding0p5'>
          <div dangerouslySetInnerHTML={ { __html: cardRegistrationGuidelinesHtml } } />
        </div>
        <div className='flexColumn alignItemsCenter borderKOM marginSide1 marginTop1 padding0p5'>
          <div className='flexColumn alignItemsFlexStart '>
            {/* asset */}
            <div className='margin1'>
              <TextLine3 fieldName='cardRegistrationAsset' keys={['cardRegistration', 'asset']} face={words.asset[state.language]} tooltip='true' />
            </div>
            {/* name */}
            <TextArea2 fieldName='cardRegistrationName' keys={['cardRegistration', 'name']} face={words.name[state.language]} boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC' />
            {/* feature */}
            <TextArea2 fieldName='cardRegistrationFeature' keys={['cardRegistration', 'feature']} face={words.profile[state.language]} boxClass='box4 margin1' textAreaClass='textArea1' />
            {/* attribute */}
            <TextArea2 fieldName='cardRegistrationAttribute' keys={['cardRegistration', 'attribute']} face={words.gender[state.language]} boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC' />
            {/* contact */}
            <TextArea2 fieldName='cardRegistrationContact' keys={['cardRegistration', 'contact']} face={words.contact[state.language]} boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC' />
            {/* mail address */}
            <TextArea2 fieldName='cardRegistrationMailAddress' keys={['cardRegistration', 'mailAddress']} face={words.mailAddressInApplyForCardRegistration[state.language]} boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC' />
          </div>
          <div className='flexColumn alignItemsFlexStart margin1'>
            <div >
              { words.pleaseLoginWithOwnerAddressInAdvance[state.language] }
            </div>
            <div >
              { words.whenUsingMpurseEtcAfterClickingTheButtonPleaseSignInThePopup[state.language] }
            </div>
          </div>
          {/* register button */}
          { registerButton }
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn ">
        { headerRelative }
        <div className='flexColumn alignItemsFlexStart widthMax borderKOM padding0p5'>
          <div dangerouslySetInnerHTML={ { __html: cardRegistrationGuidelinesHtml } } />
        </div>
        <div className='flexColumn alignItemsFlexStart widthMax borderKOM marginTop1 padding0p5'>
          {/* asset */}
          <TextLine3 fieldName='cardRegistrationAsset' keys={['cardRegistration', 'asset']} face={words.asset[state.language]} tooltip='true' />
          {/* name */}
          <TextArea2 fieldName='cardRegistrationName' keys={['cardRegistration', 'name']} face={words.name[state.language]}
            outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
          />
          {/* feature */}
          <TextArea2 fieldName='cardRegistrationFeature' keys={['cardRegistration', 'feature']} face={words.profile[state.language]}
            outerClass='widthMax' boxClass='box4 width96PC marginTop1 ' textAreaClass='textArea1'
          />
          {/* attribute */}
          <TextArea2 fieldName='cardRegistrationAttribute' keys={['cardRegistration', 'attribute']} face={words.gender[state.language]}
            outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
          />
          {/* contact */}
          <TextArea2 fieldName='cardRegistrationContact' keys={['cardRegistration', 'contact']} face={words.contact[state.language]}
            outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
          />
          {/* mail address */}
          <TextArea2 fieldName='cardRegistrationMailAddress' keys={['cardRegistration', 'mailAddress']} face={words.mailAddressInApplyForCardRegistration[state.language]}
            outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
          />
          <div className='flexColumn alignItemsFlexStart margin1'>
            <div >
              { words.pleaseLoginWithOwnerAddressInAdvance[state.language] }
            </div>
            <div >
              { words.whenUsingMpurseEtcAfterClickingTheButtonPleaseSignInThePopup[state.language] }
            </div>
          </div>
          {/* register button */}
          { registerButton }
        </div>
      </div>
      { headerFixed }
    </div>
  );
}

export {
  CardRegistration,
}
